import React, { useState } from 'react';
import AurDateRangePicker from '../../../common/aur-date-range-picker/AurDateRangePicker';

const DatePicker: React.FC = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const handleOnDateChange = (start: string, end: string) => {
    setStartDate(start);
    setEndDate(end);
  };
  return (
    <>
      <div style={{ marginBottom: '64px' }}>DatePicker</div>
      <AurDateRangePicker
        startYearFromRange={50}
        onDateChange={handleOnDateChange}
        initialEndDate={{
          year: '2020',
          day: '10',
          month: '10',
        }}
        initialStartDate={{
          year: '2019',
          day: '10',
          month: '10',
        }}
        shouldShowApplyButton={true}
      />
      <div>Start Date: {startDate}</div>
      <div>End Date: {endDate}</div>
    </>
  );
};

export default DatePicker;
